import { render, staticRenderFns } from "./flowSpecialListInfoThirteen.vue?vue&type=template&id=0bc902c9&"
import script from "./flowSpecialListInfoThirteen.vue?vue&type=script&lang=js&"
export * from "./flowSpecialListInfoThirteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports